const CardHeader = props => {
    const {className} = props;

    return (
        <div className={'card-header ' + className}>
            {props.children}
        </div>
    );
};

CardHeader.defaultProps = {
    className: ''
};

export default CardHeader;